var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pin-info-wrapper"},_vm._l((_vm.pinData),function(pinInfo,index){return _c('MoleculesProjectBuildingMoleculePinInfoContent',{key:index,attrs:{"pin-info":pinInfo}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }